// EN
export const calendarHotel = {
  btn: {
    today: "Hoje",
  },
  summary: {
    availableLabel: "Disponível",
  },
  tooltip: {
    closed: "Fechado",
    dragToCreate: "Arraste para selecionar (criar reserva)",
  },
  labels: {
    room: "quarto",
    rooms: "quartos",
    number: "NÚMERO:",
    capacityIconAlt: "Capacidade",
    maintenanceBadge: "MANUT.",
  },
  toasts: {
    reservationCreatedOk: "Reserva criada com sucesso.",
    reservationCreateErrPrefix: "Não foi possível criar a reserva: ",
    roomChangedOk: "Quarto alterado com sucesso",
    roomChangedErr: "Erro ao alterar o quarto",
    roomTypeChangedOk: "A reserva passa para {type}",
  },
  warn: {
    selectTwoDays: "Selecione pelo menos dois dias (check-in e check-out).",
  },
  errors: {
    closedForBooking: "Você não pode reservar um quarto/período fechado.",
    noAvailabilityTitle: "Sem disponibilidade",
    noAvailabilityDetail: "Não há quartos disponíveis desse tipo nessas datas.",
    noRatesTitle: "Nenhuma tarifa atribuída",
    noRatesDetail: "Não há tarifas disponíveis para esse tipo nessas datas.",
    missingDataTitle: "Dados faltando",
    missingDataDetail: "Por favor, preencha todos os campos obrigatórios.",
  },
  maintenanceModal: {
    titleFallback: "Quarto",
    statusSection: "Status",
    closeForMaintenance: "Fechar para manutenção",
    open: "Aberto",
    hint:
      "Quando um quarto está em manutenção, ele não pode ser vendido e suas células aparecem em vermelho. As reservas existentes são respeitadas.",
    actions: {
      cancel: "Cancelar",
      save: "Salvar",
      saving: "Salvando…",
    },
  },

  // ===== NEW: Reservation modal =====
  modal: {
    title: "Registrar nova reserva",
    startDate: "Check-in",
    endDate: "Check-out",
    roomType: "Tipo de quarto",
    roomTypePlaceholder: "Selecione o tipo",
    quantity: "Número de quartos",
    available: "disponível",
    guestName: "Hóspede responsável",
    guestNamePlaceholder: "Pessoa responsável pela reserva",
    guests: "Número de hóspedes",
    guestsPlaceholder: "Número de hóspedes",
    phone: "Telefone",
    email: "E-mail",
    notes: "Observação",
    notesPlaceholder: "Observações internas da reserva (ex.: chegada tardia, berço, alergias…)",
    addType: "Adicionar outro tipo de quarto",
    price: "Preço",
    pricePlaceholder: "Digite o preço",
    cancel: "Cancelar",
    create: "Criar reserva",
  },

  // ===== Validations =====
  validation: {
    minGuestsTitle: "Hóspedes insuficientes",
    minGuestsDetail: "Deve haver pelo menos {min} hóspede(s) para {rooms} quarto(s).",
    maxGuestsTitle: "Limite de hóspedes excedido",
    maxGuestsDetail: "Máximo de {maxPerRoom} hóspedes por quarto ({maxTotal} no total para {rooms} quartos).",
    maxRoomsTitle: "Limite excedido",
    maxRoomsDetail: "Você não pode reservar mais de {max} quartos.",
  },

  // ===== Promotions & Taxes =====
  promotions: {
    limitTitle: "Limite atingido",
    limitDetail: "Você não pode adicionar mais de 1 promoção.",
  },
  taxes: {
    limitTitle: "Limite atingido",
    limitDetail: "Você não pode adicionar mais de 1 imposto.",
  },
};
